import { render } from "./Fatigado.vue?vue&type=template&id=7d7bddba"
import script from "./Fatigado.vue?vue&type=script&lang=js"
export * from "./Fatigado.vue?vue&type=script&lang=js"

import "./Fatigado.vue?vue&type=style&index=0&id=7d7bddba&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__